import React from 'react';

import PropTypes from 'prop-types';
import { MdTerrain } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { SingleConfirmationModal } from '@shared/components';

import { ProgressButton } from '../../../common';
import { openRecordMiles } from '../../duck';

class RecordHikeMilesButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.confirmModalRef = React.createRef();
  }

  handleClick = () => {
    const { askForConfirmation } = this.props;
    if (askForConfirmation) {
      this.openConfirmationModal();
    } else {
      this.onOpenRecordMiles();
    }
  };

  onOpenRecordMiles = () => {
    const { onOpenRecordMiles, onClick } = this.props;
    onOpenRecordMiles();
    onClick && onClick();
  };

  openConfirmationModal = () => {
    this.confirmModalRef.current.openConfirmationModal();
  };

  handleConfirm = () => {
    const { onConfirm } = this.props;
    this.onOpenRecordMiles();
    onConfirm && onConfirm();
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    onCancel && onCancel();
  };

  render() {
    const {
      disabled,
      className,
      children,
      askForConfirmation,
      confirmationMessage,
      disableConfirmBtn,
      replaceButton,
    } = this.props;
    const button = replaceButton ? (
      React.cloneElement(replaceButton, { onClick: this.handleClick })
    ) : (
      <ProgressButton
        color="scouting-warm-gray"
        noBorder
        fitText
        disabled={disabled}
        icon={<MdTerrain />}
        className={className}
        onClick={this.handleClick}
      >
        {children || (
          <FormattedMessage id="hikes.RecordHikeMilesButton.label" />
        )}
      </ProgressButton>
    );

    return (
      <React.Fragment>
        {askForConfirmation && (
          <SingleConfirmationModal
            ref={this.confirmModalRef}
            disableConfirm={disableConfirmBtn}
            confirmBtnText={<FormattedMessage id="shared.confirm" />}
            onCancel={this.handleCancel}
            message={confirmationMessage}
            onConfirm={this.handleConfirm}
          />
        )}
        {button}
      </React.Fragment>
    );
  }
}

const validateIfAskForConfirm =
  validator =>
  (props, ...args) => {
    if (props.askForConfirmation) {
      return validator(props, ...args);
    }
  };

RecordHikeMilesButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  userIds: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  onOpenRecordMiles: PropTypes.func.isRequired,
  askForConfirmation: PropTypes.bool,
  disableGetActivities: PropTypes.bool,
  disableFutureDays: PropTypes.bool,
  allowRemovePersons: PropTypes.bool,
  replaceButton: PropTypes.node,
  disableConfirmBtn: validateIfAskForConfirm(PropTypes.bool),
  confirmationMessage: validateIfAskForConfirm(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  ),
  onCancel: validateIfAskForConfirm(PropTypes.func),
  onConfirm: validateIfAskForConfirm(PropTypes.func),
};

const mapDispatch = (
  dispatch,
  { userIds, disableGetActivities, disableFutureDays, allowRemovePersons },
) => ({
  onOpenRecordMiles: () =>
    dispatch(
      openRecordMiles(
        userIds,
        disableGetActivities,
        disableFutureDays,
        allowRemovePersons,
      ),
    ),
});

export default connect(null, mapDispatch)(RecordHikeMilesButton);
